import React from 'react';

import { Helmet } from 'react-helmet';

import { Container } from '@mui/material';

import PageSubheader from '~/components/Common/Elements/PageSubheader';

import GHADiscountSummaryTable from './GHADiscountSummaryTable';

// GHA-442: read-only overview of the currently active GHA discounts per account — live-property
// tier counts, the active discount estate, and the exclusion rules. Deliberately shows every
// account (LE and Scoopon brands together) so the whole discount estate reads in one place.
export default function GHADiscountSummaryContainer() {
  return (
    <Container maxWidth="lg">
      <Helmet>
        <title>GHA Property Discount Summary</title>
      </Helmet>
      <PageSubheader title="GHA Property Discount Summary" />
      <GHADiscountSummaryTable />
    </Container>
  );
}
